export default __webpack_public_path__ + "static/media/slide5.2a177bbe.jpg";